"use client";
import { faq as defaultFaq } from "@/data/data";
import FaqAreaBar from "./faq-area-bar";

interface Props {
    style?: "style-1" | "style-2";
    title?: string
    items?: { id: number; question: string; answer: string }[]
}

const FaqArea = ({ style, title, items }: Props) => {
    const data = items && items.length > 0 ? items : defaultFaq;
    return (
        <section
            id="desilo-faq-area"
            className={`desilo-faq-area bg-color-white overflow-hidden ${style === 'style-1'
                ? 'section-padding-top'
                : style === 'style-2'
                    ? ''
                    : 'section-padding-top-bottom'
                }`}
        >
            <div className="container custom-container">
                <div className="row g-4 justify-content-between">
                    <div className="col-lg-6 col-xl-5 col-xxl-4 gsap-sticky">
                        <div className="desilo__header">
                            <h2 className="title">
                                {title}
                            </h2>
                        </div>
                    </div>
                    <div className="col-lg-6 col-xl-7 col-xxl-7">
                        <div
                            className="accordion desilo-faq-accordion"
                            id="accordionExample"
                        >
                            {/* faq bar start */}
                            {data.map((item, i) => (
                                <FaqAreaBar key={i} data={item} i={i} />
                            ))}
                            {/* faq bar end */}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default FaqArea;
